export const filter = {
  id : '',  
  nationality: '', 
  created_at: '',
  updated_at: ''  
};
